import { render } from "./AppFooter.vue?vue&type=template&id=76855bf1"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/harry/Desktop/Vuejs Project/Sudavas/sudavas.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__